import { useState } from 'react'
import { VpDivider } from '@vtmn-play/react/VpDivider'
import { Language } from '@/domains/Language'
import { useTranslation } from 'react-i18next'
import { SearchItem } from '@/src/components/search-item/SearchItem'

export type CategoryListProps = {
  languages: Language[]
  onSelect: (language: Language) => void
  selectedId?: number | null
}

export const LanguageList = ({ languages, onSelect, selectedId }: CategoryListProps) => {
  const { t } = useTranslation('common')
  const [localSelectedId, setLocalSelectedId] = useState<number | null>(null)
  const currentSelectedLanguageId = selectedId ?? localSelectedId

  const handleSelect = (lang: Language) => {
    setLocalSelectedId(lang.id)
    onSelect(lang)
  }

  return (
    <ul className="mt-6">
      {languages.map((language, i) => (
        <div key={language.id}>
          <SearchItem
            label={`${language.flag} ${t(language.nameKey)}`}
            data-testid={language.code + '-language-item'}
            selected={language.id === currentSelectedLanguageId}
            onClick={() => handleSelect(language)}
          />
          {i < languages.length - 1 && (
            <li aria-hidden="true">
              <VpDivider />
            </li>
          )}
        </div>
      ))}
    </ul>
  )
}
